module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-api-choice-container body"
  }, [(_vm.title !== undefined && _vm.title !== null) ? _c('h4', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]) : _vm._e(), _vm._v(" "), (!!_vm.caption) ? _c('p', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.caption))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "choice-container"
  }, _vm._l((_vm.choices), function(choice) {
    return _c('div', {
      key: choice.index,
      staticClass: "choice-box-wrapper"
    }, [_c('div', {
      staticClass: "choice-box",
      on: {
        "click": function($event) {
          return _vm.resolve(choice)
        }
      }
    }, [(('name' in choice) && choice.name !== null && choice.name !== '') ? _c('h5', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(choice.name) + "\n          ")]) : _c('h5', {
      staticClass: "title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('errors.api_error_modal.no_name')) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "choice-info"
    }, [_c('ul', _vm._l((_vm.listItems), function(attribute) {
      return _c('li', {
        key: attribute
      }, [(choice[attribute]) ? _c('p', {
        staticClass: "caption list-item"
      }, [_vm._v("\n                  " + _vm._s(choice[attribute]) + "\n                ")]) : _vm._e()])
    }), 0)])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a85780a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/UserApiChoice.vue
// module id = 1914
// module chunks = 0